<template>
  <div class="services-categories-page page">
    <ServicesHeader
      @loaded="loading = false"
      @error="setError"
      :breadcrumbs="breadcrumbs"
      :title="pageTitle"
    />
    <div v-if="loading && !is403Error" class="page-loading">
      {{ $t("services.loading") }}
    </div>
    <div v-else-if="is403Error" class="page-loading">
      {{ $t("event.error403") }}
    </div>
    <template v-else>
      <div class="services-categories-page__inner page__inner container">
        <div v-if="categories?.length" class="services-categories-page__list">
          <MainCategoryComponent
            v-for="(item, i) in categories"
            :key="i"
            :data="item"
          />
        </div>
        <span v-else class="services-categories-page__empty">
          Категории отсутствуют
        </span>
        <EventPopularServices
          class="services-categories-page__popular-services"
          :event-id="eventId"
          full-width
        />
      </div>
    </template>
  </div>
</template>

<script>
import ServicesHeader from "@/components/Custom/ServicesHeader.vue";
import MainCategoryComponent from "@/components/Custom/MainCategoryComponent.vue";
import EventPopularServices from "@/components/Custom/EventPopularServices.vue";
import { mapGetters } from "vuex";

export default {
  name: "ServicesCategoriesPage",
  components: {
    EventPopularServices,
    ServicesHeader,
    MainCategoryComponent
  },
  data() {
    return {
      loading: true,
      is403Error: false,
      breadcrumbs: [
        {
          title_rus: "Выставка",
          title_eng: "Exhibition",
          route: { name: "participant", params: { id: this.$route.params.id } }
        }
      ]
    };
  },
  computed: {
    ...mapGetters("services", ["categories"]),
    ...mapGetters("event", ["eventId"]),
    pageTitle() {
      let titleLocale = {
        title_rus: "Дополнительные услуги",
        title_eng: "Additional services"
      };
      return this.$options.filters.localeField(titleLocale, "title");
    }
  },
  methods: {
    setError() {
      this.loading = false;
      this.is403Error = true;
    }
  }
};
</script>

<style lang="scss">
.services-categories-page {
  .container {
    width: 100%;
    @media (max-width: 740px) {
      width: auto;
    }
  }
  &__notification {
    margin: 15px;
  }
  &__empty {
    font-weight: 500;
    font-size: 1rem;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    margin: -15px;
    @media (max-width: 540px) {
      margin: -8px;
    }

    .main-category {
      margin: 15px;
      width: calc(50% - 30px);
      @media (max-width: 740px) {
        width: 100%;
      }
      @media (max-width: 540px) {
        margin: 8px;
      }
    }
  }

  &__popular-services {
    margin-top: 50px;
    @media (max-width: 540px) {
      margin-top: 30px;
    }
  }
}
</style>
